import { useState } from 'react';

const SOURCE_LABEL = {
  pubmed: 'PubMed',
  arxiv: 'arXiv',
  semantic_scholar: 'Semantic Scholar',
  openalex: 'OpenAlex',
  europepmc: 'Europe PMC',
  europe_pmc: 'Europe PMC',
  biorxiv: 'bioRxiv',
  medrxiv: 'medRxiv',
  doi: 'DOI Import',
  bibtex: 'BibTeX',
  ris: 'RIS',
  pdf: 'PDF Import',
  zotero: 'Zotero',
};

const SOURCE_TOOLTIP = {
  openalex: 'OpenAlex · 250M+ scholarly works, filtered to life sciences & health sciences',
  pubmed: 'PubMed · NCBI biomedical literature database',
  europepmc: 'Europe PMC · Open access life sciences literature',
  europe_pmc: 'Europe PMC · Open access life sciences literature',
  biorxiv: 'bioRxiv · Biology preprints',
  medrxiv: 'medRxiv · Medical preprints',
  semantic_scholar: 'Semantic Scholar · AI-powered academic search',
};

export default function PaperCard({ paper, onAddToWorkspace, isInWorkspace }) {
  const [expanded, setExpanded] = useState(false);

  const sourceLabel = SOURCE_LABEL[paper.source] || paper.source;
  const sourceTooltip = SOURCE_TOOLTIP[paper.source];
  const authorDisplay =
    paper.authors && paper.authors.length > 0
      ? paper.authors.join(', ')
      : 'Unknown authors';

  return (
    <div
      className="bg-white rounded-lg p-4"
      style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px, rgba(0,0,0,0.04) 0px 2px 2px, #fafafa 0px 0px 0px 1px inset' }}
    >
      <h3 className="text-sm font-semibold text-[#171717] mb-1 leading-snug" style={{ letterSpacing: '-0.32px' }}>
        {paper.title || 'Untitled'}
      </h3>

      <p className="text-xs text-[#4d4d4d] mb-1.5">{authorDisplay}</p>

      <div className="flex items-center gap-2 mb-2">
        <span
          className="text-xs font-medium px-2 py-0.5 rounded-full text-[#4d4d4d]"
          style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
          title={sourceTooltip}
        >
          {sourceLabel}
        </span>
        {paper.published_date && (
          <span className="text-xs text-[#808080]">{paper.published_date}</span>
        )}
      </div>

      {paper.abstract ? (
        <div className="mb-2">
          <p className={`text-xs text-[#4d4d4d] leading-relaxed ${expanded ? '' : 'line-clamp-3'}`}>
            {paper.abstract}
          </p>
          {paper.abstract.length > 200 && (
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-xs text-[#171717] hover:underline mt-1 font-medium"
            >
              {expanded ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
      ) : (
        <p className="text-xs text-[#808080] italic mb-2">No abstract available.</p>
      )}

      <div className="flex items-center justify-between mt-2">
        {paper.doi_url ? (
          <a
            href={paper.doi_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[#4d4d4d] hover:text-[#171717] hover:underline truncate max-w-xs"
          >
            {paper.doi_url}
          </a>
        ) : (
          <span />
        )}

        <button
          onClick={() => !isInWorkspace && onAddToWorkspace(paper)}
          disabled={isInWorkspace}
          className={`ml-2 flex-shrink-0 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
            isInWorkspace
              ? 'text-[#808080] cursor-not-allowed'
              : 'bg-[#171717] text-white hover:bg-[#2e2e2e]'
          }`}
          style={isInWorkspace ? { boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' } : {}}
        >
          {isInWorkspace ? 'In Workspace' : 'Add to Workspace'}
        </button>
      </div>
    </div>
  );
}
